<template>
  <div class="v-application--wrap">
    <v-content>
      <v-container fluid fill-height>
        <v-layout :align-center="alignCenter" justify-center flex-wrap>
          <slot>
            <router-view />
          </slot>
        </v-layout>
      </v-container>
    </v-content>
  </div>
</template>

<script>
export default {
  name: "LayoutEmpty",
  props: {
    layoutClass: {
      type: String,
      default: ''
    },
    alignCenter: {
      type: Boolean,
      default: true
    }
  },
  components: {},

  data: () => ({
    //
  })
};
</script>
<style lang="scss">
</style>
